import { SyntheticEvent, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useQueryClient } from '@tanstack/react-query'

import { ProfileMenu } from '@weberlo/components'

import useAuth from 'hooks/useAuth'
import useConfig from 'hooks/useConfig'
import useIsAdmin from 'hooks/useIsAdmin'

import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined'
import developerIcon from 'assets/icons/sidebar/developer.svg'
import logoutIcon from 'assets/icons/universal/log-out.svg'
import profileIcon from 'assets/icons/universal/user.svg'

// ==============================|| HEADER CONTENT - PROFILE ||============================== //

const Profile = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const queryClient = useQueryClient()

  const { onChangeWorkspace } = useConfig()

  const { logout, user } = useAuth()
  const { isAdmin } = useIsAdmin()

  const handleLogout = async () => {
    try {
      await logout()
      onChangeWorkspace('', '', '')
      queryClient.clear()
    } catch (err) {
      console.error(err)
    }
  }

  const anchorRef = useRef<any>(null)
  const [open, setOpen] = useState(false)
  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleClose = (event: MouseEvent | TouchEvent) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setTimeout(() => setOpen(false), 300)
  }

  const onClick = (e: SyntheticEvent, route: string) => {
    navigate(route)
    setTimeout(() => setOpen(false), 300)
  }

  const isSelected = (route: string) => {
    return location.pathname === route
  }

  const menu = [
    {
      id: 'profile',
      icon: (
        <img
          alt="profile icon"
          src={profileIcon}
        />
      ),
      label: 'Profile',
      onClick: (e: SyntheticEvent) => onClick(e, '/profile'),
      selected: isSelected('/profile'),
    },
    {
      id: 'developer',
      icon: (
        <img
          alt="developer icon"
          src={developerIcon}
        />
      ),
      label: 'Developer',
      onClick: (e: SyntheticEvent) => onClick(e, '/developer/api'),
      selected: isSelected('/developer/api'),
    },
    // Only for ADMIN_USER_IDS; the server enforces it, this just shows the link.
    ...(isAdmin
      ? [
          {
            id: 'admin',
            icon: <AdminPanelSettingsOutlinedIcon sx={{ fontSize: 20 }} />,
            label: 'Admin',
            onClick: (e: SyntheticEvent) => onClick(e, '/admin'),
            selected: isSelected('/admin'),
          },
        ]
      : []),
    {
      id: 'logout',
      icon: (
        <img
          alt="logout icon"
          src={logoutIcon}
        />
      ),
      label: 'Logout',
      onClick: handleLogout,
    },
  ]

  return (
    <ProfileMenu
      open={open}
      anchorEl={null}
      handleClick={handleToggle}
      onClose={handleClose}
      menuItems={menu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      userEmail={user?.attributes?.email || ''}
      username={user?.attributes?.name || ''}
    />
  )
}

export default Profile
